export default __webpack_public_path__ + "static/media/El_Manial.d0974f0c.jpg";